// extracted by mini-css-extract-plugin
export var workContent = "featured-work-card-module--work-content--3XIQ4";
export var workIcon = "featured-work-card-module--work-icon--FqapF";
export var workImage = "featured-work-card-module--work-image--ZPh7c";
export var workItem = "featured-work-card-module--work-item--lP3mk";
export var workText = "featured-work-card-module--work-text--GiQjh";
export var workTitle = "featured-work-card-module--work-title--T5wxr";